'use client';
import { useEffect, useState } from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import LogoutButton from '../logout';
import UserCard from './usercard';
import Menu from './Menu';
import Links from './Links';
import { FaSignOutAlt } from 'react-icons/fa';
import { LiaBarsSolid } from 'react-icons/lia';
import { getAuthDataFromEncryptedCookie } from '@src/server-action/auth';

// Store
import useStore from '@store';

export default function Mobile({}) {
	const $state = useStore();
	const { user } = $state?.auth || {};
	const role = user?.profile?.member_type.toLowerCase();
	const [open, setOpen] = useState(false);

	const toggleOpen = () => {
		setOpen(!open);
	};

	return (
		<>
			<button
				onClick={toggleOpen}
				className={`flex xl:hidden cursor-pointer items-center justify-center`}>
				<LiaBarsSolid className={`text-white text-2xl`} />
			</button>

			{/* Blue Panel */}
			<div
				onClick={toggleOpen}
				style={{ transform: open ? '' : 'translateX(150%)' }}
				className={`fixed z-50 top-0 right-0 bg-[#4444DA] w-[80%] h-full border-l-2 border-[#2662B6] p-4 py-8 flex flex-col justify-start gap-4 transform transition-transform duration-700 ease-in-out max-h-full overflow-y-auto ${
					open ? 'translate-x-0' : 'translate-x-full'
				}`}>
				{/* Close */}
				<button
					onClick={toggleOpen}
					className='flex flex-row items-center justify-end text-white gap-2 cursor-pointer'>
					<span>Close</span>
					<span
						className={`flex flex-row items-center justify-center rounded-full size-7 bg-white text-[#4444DA]`}>
						<IoCloseOutline className={`text-xl`} />
					</span>
				</button>
				{/* User Card */}
				{['parent', 'teacher', 'staff'].includes(role) && (
					<UserCard auth={user} />
				)}
				{/* Menu Options */}
				<Menu />
				{/* Extra Links */}
				<Links auth={user} />
				{/* Logout */}
				<LogoutButton
					iconEnd={<FaSignOutAlt />}
					label={'Logout'}
					className={`bg-[#3232C2] flex flex-row items-center justify-between p-4 mt-6 rounded-md cursor-pointer text-white`}
				/>
			</div>

			{/* Side shadow (with close action) */}
			<div
				onClick={toggleOpen}
				style={{ transform: open ? '' : 'translateX(-100%)' }}
				className={`fixed cursor-pointer z-50 top-0 left-0 w-[20%] h-full bg-[#00000090] transition-opacity delay-500 duration-300 ease-in ${
					open ? 'opacity-100' : 'opacity-0'
				}`}></div>
		</>
	);
}
